export const theme = {
  colors: {
    primary: '#402563',
    secondary: '#2042ba',
    background: {
      light: '#2a2a2a',
      dark: '#1a1a1a',
      card: '#2d2d2d',
    },
    text: {
      light: '#ffffff',
      muted: 'rgba(255, 255, 255, 0.7)',
      dark: '#8c8c8c',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #402563, #114ee0)',
      secondary: 'linear-gradient(135deg, #402563, #2042ba)',
      success: 'linear-gradient(45deg, #1b5e20, #43a047)',
      warning: 'linear-gradient(45deg, #e65100, #fb8c00)',
      info: 'linear-gradient(45deg, #006064, #00acc1)',
    },
  },
  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '2.5rem',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
  breakpoints: {
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xl: '1400px',
  },
  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.2)',
    md: '0 4px 8px rgba(0, 0, 0, 0.3)',
    lg: '0 8px 16px rgba(0, 0, 0, 0.4)',
  },
  transitions: {
    default: 'all 0.3s ease',
    fast: 'all 0.2s ease',
  },
  // Legacy flat aliases for backward compatibility with existing styled components
  // Prefer using nested keys (colors.*, spacing.*, etc.) going forward
  bgLight: '#2a2a2a',
  bgDark: '#1a1a1a',
  textLight: '#ffffff',
  textMuted: 'rgba(255, 255, 255, 0.7)',
  textDark: '#8c8c8c',
  primary: '#402563',
  secondary: '#2042ba',
  dark: '#1a1a1a',
} as const

export type Theme = typeof theme
